import Endpoints from "@/config/ApiEndpoints.js";
import Axios from "axios";
import $ from "jquery";
import UpcomingEvent from "@/pages/upcomingevent/upcomingevent";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import VehicleRegistrationRegion from "@/assets/js/vehicle_registration_region.js";
import VehicleOverView from "@/pages/vehicles/vehicleoverview/vehicleoverview";
import VehicleMaps from '@/pages/vehicles/vehiclemaps/vehiclemaps.vue';
import Task from "@/pages/task/task";
import { googleMapApiKey } from "@/constants/config";
import VehicleAssetsPopup from '@/pages/vehicles/vehicleassetpopup/vehicleassetpopup.vue';
var moment = require("moment");

// Filter keys whose <select> options bind numeric ids, so values restored from
// the URL query string have to be cast back to Number for v-model to match.
const NumericSearchKeys = ["branch_id", "vehicle_group"];

// How many page numbers to show either side of the current one in the pager.
const PageWindow = 2;

// How far outside the viewport a card starts fetching its vehicle image, so the
// picture is normally there by the time the user has scrolled it into view.
const VehicleImageRootMargin = "300px 0px";

export default {
  components: {
    UpcomingEvent,
    VuePerfectScrollbar,
    VehicleOverView,
    VehicleMaps,
    Task,
    VehicleAssetsPopup
  },
  directives: {
    // Hands the vehicle image slot to the shared IntersectionObserver, and
    // takes it back off again when the card is re-rendered or paged away.
    LazyVehicleImage: {
      inserted(el, binding, vnode) {
        el.dataset.vehicleId = binding.value;
        vnode.context.ObserveVehicleImage(el);
      },
      unbind(el, binding, vnode) {
        vnode.context.UnobserveVehicleImage(el);
      },
    },
  },
  filters: {
    date: function (data) {
      var sendDate = "N/A";
      if (data != "" && data != null) {
        sendDate = moment(data).format("DD-MM-YYYY");
      }
      return sendDate;
    },
    region: function (data) {
      return VehicleRegistrationRegion(data);
    },
  },
  data() {
    return {
      trackingModule: false,
      settings4: {
        maxScrollbarLength: 60,
        suppressScrollY: true,
      },
      CompanyData: "",
      SearchLoader: false,
      ShowLoader: false,
	    UnsafeShowLoader: false,
      trailersModule: false,
      assetsModule: false,
      ShowTrailerDetailPopup: false,
      SearchKey: "",
      VehicleImageEndpoint: Endpoints.Helper.GenerateImage + "/",
      ImageEndpoint: Endpoints.Helper.Image + "/",
      Vehicles: [],
      // Keyed by vehicle id: true once that card's image has loaded or failed.
      VehicleImageLoaded: {},
      // Keyed by vehicle id: true once that card has come within reach of the
      // viewport. Until then its <img> has no src, so the image is never
      // requested for a card the user has not scrolled towards.
      VehicleImageVisible: {},
      // Cleared when the browser has no IntersectionObserver, in which case
      // every card requests its image up front as it did before.
      VehicleImageLazySupported: true,
      Drivers: [],
      TrailerData: [],
      Groups:[],
      AssginVehicle: { driver_id: 0, vehicle_id: 0 },
      UpcomingEvent: {},
      DashboardData: {},
      DashboardDetailHeading: "",
      VehicleWarningCnt: 0,
      Branches: {},
      Make: {},
      Models: {},
      VehicleTypes: {},
      DashboardReportData:{},
      SearchData: {
        branch_id: "",
        vehicle_group: "",
        vehicle_type: "",
        vehicle_assigned: "",
        vehicle_status: "",
        make: "",
        model: "",
      },

      VehiclePositionModelVehicleId: 0,
      ShowVehiclePositionModel: false,
      LastVehiclePosition: {},
      center: {
        lat: 55.232753,
        lng: -3.944403,
      },
      locationMarkers: [],
      Pagination: {
        current_page: 1,
        last_page: 1,
        per_page: 16,
        total: 0,
        from: 0,
        to: 0,
      },
      ListRequestId: 0,
      ExportLoader: false,

      ShowVehicleDetails: false,
      ShowUrgentTask: false,
      VehicleListLoaded: false,
      FleetSubscription:[],
      lastUpdatedPosition:"",
      todaysUrgentTaskNew: window.todaysUrgentTaskNew,
      ShowVehicleAssetsModel: false,
      AssetsList:[],
      ShowAssetsDetails:false,
    };
  },
  mounted() {
    //check account permission
    var AccountPermissions = JSON.parse(
      localStorage.getItem("AccountPermissions")
    );
    this.FleetSubscription = JSON.parse(
      localStorage.getItem("FleetSubscription")
    );
    var FleetSubscriptionModules = JSON.parse(
      this.FleetSubscription.fleet_modules
    );
    if(FleetSubscriptionModules["Hierarchy System"] && (!AccountPermissions.Vehicle || !AccountPermissions.Vehicle.enable)){
      this.$router.push('/');
    }

    if (AccountPermissions && 
      AccountPermissions.Vehicle &&
      AccountPermissions.Vehicle.enable) {
      if (AccountPermissions.Vehicle.view) {
        this.ShowVehicleDetails = true;
      }
    }

    if (AccountPermissions && 
			AccountPermissions['Vehicle Checks'] &&
			AccountPermissions['Vehicle Checks']['enable']) {
			if ( AccountPermissions['Vehicle Checks']['view_urgent_task']) {
				this.ShowUrgentTask = true;
			}
		}

		if (!FleetSubscriptionModules["Hierarchy System"]) {
        this.ShowUrgentTask = true;
        this.ShowVehicleDetails = true;
        this.ShowAssetsDetails = true;
		}

    this.CompanyData = JSON.parse(localStorage.getItem("Company"));
    if (this.CompanyData && this.CompanyData.name) {            
      if(window.taskModuleCompanies.includes(this.CompanyData.id)){ 
      	this.todaysUrgentTaskNew = true
      }
    } 
    document.title = pbx_SiteTitle + " - Vehicles List";
    this.CreateVehicleImageObserver();
    this.ApplyRouteQuery();
    this.GetGroups();
    this.GetCompanySubscriptionModule();
    this.GetVehiclesList();
    this.GetUnSafeVehicle();
    this.GetBranches();
    this.GetMake();
    this.GetVehicleTypes();
    if (this.SearchData.make != "") {
      this.GetModel();
    }
    $(".closeDashboardDetail").on("click", function (event) {
      $("#DashboardDetailPopup").hide();
    });
  },
  beforeDestroy() {
    if (this.VehicleImageObserver) {
      this.VehicleImageObserver.disconnect();
      this.VehicleImageObserver = null;
    }
  },
  computed: {
    // Page numbers to render, windowed around the current page with "..." gaps
    // so a 63 page fleet does not produce 63 buttons.
    PageNumbers() {
      var last = this.Pagination.last_page;
      var current = this.Pagination.current_page;
      var pages = [];
      if (last <= 1) {
        return pages;
      }
      var start = Math.max(2, current - PageWindow);
      var end = Math.min(last - 1, current + PageWindow);
      pages.push(1);
      if (start > 2) {
        pages.push("...");
      }
      for (var i = start; i <= end; i++) {
        pages.push(i);
      }
      if (end < last - 1) {
        pages.push("...");
      }
      pages.push(last);
      return pages;
    },
  },
  watch: {
    // Browser back/forward (and any other external change to the query string)
    // replays that page/filter state onto the list. Our own SyncRouteQuery()
    // pushes land here too, but their signature already matches so they no-op.
    "$route"(to) {
      if (to.name != "Vehicles") {
        return;
      }
      if (this.QuerySignature(to.query) == this.QuerySignature(this.BuildQuery())) {
        return;
      }
      this.ApplyRouteQuery();
      this.GetVehiclesList();
    },
  },
  methods: {
    GetGroups() {
      var obj = {
        token: localStorage.getItem("token"),
      };
      Axios.post(Endpoints.Groups.List, obj).then((Response) => {
        this.ShowLoader = false;
        if (Response?.data?.success) {
          this.Groups = Response.data.records;
        }
      });
    },
    GetUnSafeVehicle() {
      Axios.post(Endpoints.Dashboard.DashboardReportData, {
        token: localStorage.getItem("token"),
        type: 'vehicleunsafe',
        item_type:'VehicleList'
      }).then((Response) => {
        if (Response?.data?.success) {
          this.DashboardReportData = Response.data.DashboardReportData;
        }
      });
    },
    GetCompanySubscriptionModule(){
    	var FleetSubscription = JSON.parse(localStorage.getItem("FleetSubscription"));
    	var fleet_modules = JSON.parse(FleetSubscription['fleet_modules']);    	
    	const isTrailer = fleet_modules['Trailers'];
		if (isTrailer) {
			this.trailersModule = true;
		}
		const isTracking = fleet_modules['Vehicle Tracking'];
		if (isTracking) {
			this.trackingModule = true;
		}
    const isAsset = fleet_modules['Assets'];
		if (isAsset) {
			this.assetsModule = true;
		}
    },
    GetCompanySubscription() {
      var FleetSubscriptionModules = JSON.parse(
				JSON.parse(localStorage.getItem("FleetSubscription")).fleet_modules
			);
      const isTrailer = FleetSubscriptionModules.Trailers;
      if (isTrailer) {
        this.trailersModule = true;
      }
      const isTracking = FleetSubscriptionModules["Vehicle Tracking"];
      if (isTracking) {
        this.trackingModule = true;
      }
    },
    SetTrailerInfo(TrailerId) {
      Axios.post(Endpoints.Trailer.Get, {
        token: localStorage.getItem("token"),
        trailer_id: TrailerId,
      }).then((Response) => {
        if (Response?.data?.success) {
          this.TrailerData = Response.data.trailer;
        }else{
          this.$router.push("/error-404");
        }
      });
      this.ShowTrailerDetailPopup = true;
    },
    GetBranches() {
      var obj = { token: localStorage.getItem("token"), select_branch: true };
      Axios.post(Endpoints.Branch.List, obj).then((Response) => {
        if (Response?.data?.success) {
          this.Branches = Response.data.records;
        }
      });
    },
    GetMake() {
      var obj = { token: localStorage.getItem("token") };
      Axios.post(Endpoints.Vehicle.GetVehicleMake, obj).then((Response) => {
        if (Response?.data?.success) {
          this.Make = Response.data.records;
        }
      });
    },
    GetModel() {
      var obj = {
        token: localStorage.getItem("token"),
        make: this.SearchData.make,
      };
      Axios.post(Endpoints.Vehicle.GetVehicleModel, obj).then((Response) => {
        if (Response?.data?.success) {
          this.Models = Response.data.records;
        }
      });
    },
    GetVehicleTypes() {
      var obj = { token: localStorage.getItem("token") };
      Axios.post(Endpoints.Vehicle.GetVehicleTypes, obj).then((Response) => {
        if (Response?.data?.success) {
          this.VehicleTypes = Response.data.records;
        }
      });
    },
   
    SearchVehicle(type = null) {
      if (type == "make") {
        this.SearchData.model = "";
        if (this.SearchData.make == "") {
          this.Models = [];
        }
      }

      // Any change of filter or search key restarts at page one.
      this.Pagination.current_page = 1;
      this.SyncRouteQuery();
      this.GetVehiclesList();
    },
    MarkVehicleImageLoaded(Vehicle) {
      if (!Vehicle || Vehicle.id == null) {
        return;
      }
      // $set so the template picks the change up: the keys are not known when
      // VehicleImageLoaded is created.
      this.$set(this.VehicleImageLoaded, Vehicle.id, true);
    },
    // --- Lazy vehicle images -------------------------------------------------
    // Each image is generated on demand server side from the VRM, so asking for
    // one is expensive. A page of cards is taller than the viewport, so only
    // the cards the user is actually scrolling towards ask for theirs.
    CreateVehicleImageObserver() {
      if (typeof IntersectionObserver == "undefined") {
        this.VehicleImageLazySupported = false;
        return;
      }
      // Kept off data() on purpose: the observer is not template state and
      // does not want to be walked by the reactivity system.
      this.VehicleImageObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) {
              return;
            }
            this.MarkVehicleImageVisible(entry.target.dataset.vehicleId);
            // One shot: once a card has been reached its image stays
            // requested, so scrolling back past it does not re-fetch it.
            this.UnobserveVehicleImage(entry.target);
          });
        },
        { rootMargin: VehicleImageRootMargin }
      );
    },
    ObserveVehicleImage(el) {
      if (!this.VehicleImageObserver) {
        return;
      }
      this.VehicleImageObserver.observe(el);
    },
    UnobserveVehicleImage(el) {
      if (!this.VehicleImageObserver) {
        return;
      }
      this.VehicleImageObserver.unobserve(el);
    },
    MarkVehicleImageVisible(VehicleId) {
      if (VehicleId == null || VehicleId === "") {
        return;
      }
      this.$set(this.VehicleImageVisible, VehicleId, true);
    },
    ShouldLoadVehicleImage(Vehicle) {
      if (!Vehicle || Vehicle.id == null) {
        return false;
      }
      if (!this.VehicleImageLazySupported) {
        return true;
      }
      return this.VehicleImageVisible[Vehicle.id] === true;
    },
    // Builds the request body shared by the list request and the export, so an
    // export always covers exactly what the current filters are showing.
    BuildListRequest(page) {
      var obj = {
        token: localStorage.getItem("token"),
        paginate: true,
        page: page,
      };
      if (this.SearchKey != "") {
        obj.searchkey = this.SearchKey;
      }
      obj.SearchData = this.SearchData;
      return obj;
    },
    GetVehiclesList() {
      this.ShowLoader = true;
      this.SearchLoader = true;
      this.Vehicles = [];
      this.VehicleImageLoaded = {};
      this.VehicleImageVisible = {};
      // Clicking through pages quickly can land responses out of order, so only
      // the newest request is allowed to write to the grid.
      this.ListRequestId++;
      var requestId = this.ListRequestId;
      Axios.post(
        Endpoints.Vehicle.List + '?view=vlist',
        this.BuildListRequest(this.Pagination.current_page)
      ).then((Response) => {
        if (requestId != this.ListRequestId) {
          return;
        }
        this.ShowLoader = false;
        this.SearchLoader = false;
        if (Response?.data?.success) {
          var Paginator = Response.data.vehicles || {};
          // AdditionalFilters() unsets entries server side, so data can come
          // back as an object with gaps in its keys rather than an array.
          this.Vehicles = Object.values(Paginator.data || {});
          this.SetPagination(Paginator);
          this.VehicleListLoaded = true;

          // A page beyond the end (stale URL, or a filter that shrank the
          // result set) lands on the last real page instead of showing blank.
          if (
            this.Vehicles.length == 0 &&
            this.Pagination.last_page > 0 &&
            this.Pagination.current_page > this.Pagination.last_page
          ) {
            this.Pagination.current_page = this.Pagination.last_page;
            this.SyncRouteQuery();
            this.GetVehiclesList();
          }
        }
      }).catch((error) => {
        if (requestId != this.ListRequestId) {
          return;
        }
        this.ShowLoader = false;
        this.SearchLoader = false;
        console.error("Error fetching vehicles list:", error);
      });
    },
    SetPagination(Paginator) {
      this.Pagination.current_page = Number(Paginator.current_page) || 1;
      this.Pagination.last_page = Number(Paginator.last_page) || 1;
      this.Pagination.per_page =
        Number(Paginator.per_page) || this.Pagination.per_page;
      this.Pagination.total = Number(Paginator.total) || 0;
      this.Pagination.from = Number(Paginator.from) || 0;
      this.Pagination.to = Number(Paginator.to) || 0;
    },
    GoToPage(page) {
      if (page == "..." || page < 1 || page > this.Pagination.last_page) {
        return;
      }
      if (page == this.Pagination.current_page) {
        return;
      }
      this.Pagination.current_page = page;
      this.SyncRouteQuery();
      this.GetVehiclesList();
      this.ScrollToVehicleCards();
    },
    // Puts the top of the card grid just below the header, so paging does not
    // throw the user back up past the search box and filters. The header is
    // fixed at some breakpoints and static at others, so measure it rather
    // than assuming a height.
    ScrollToVehicleCards() {
      var anchor = this.$refs.VehiclesGridTop;
      if (!anchor) {
        return;
      }
      var offset = 0;
      var header = document.querySelector(".page-header");
      if (header && window.getComputedStyle(header).position == "fixed") {
        offset = header.offsetHeight;
      }
      var top =
        anchor.getBoundingClientRect().top + window.pageYOffset - offset - 10;
      window.scrollTo({ top: top > 0 ? top : 0, behavior: "smooth" });
    },
    // --- URL query string <-> page state -------------------------------------
    // The query string is what makes a page shareable and lets it survive a
    // refresh or a back button, so page and filters are mirrored into it.
    BuildQuery() {
      var query = {};
      if (this.SearchKey != "") {
        query.searchkey = this.SearchKey;
      }
      Object.keys(this.SearchData).forEach((key) => {
        if (this.SearchData[key] !== "" && this.SearchData[key] !== null) {
          query[key] = String(this.SearchData[key]);
        }
      });
      if (this.Pagination.current_page > 1) {
        query.page = String(this.Pagination.current_page);
      }
      return query;
    },
    QuerySignature(query) {
      return Object.keys(query || {})
        .filter(
          (key) =>
            query[key] !== "" && query[key] !== null && query[key] !== undefined
        )
        .sort()
        .map((key) => key + "=" + query[key])
        .join("&");
    },
    ApplyRouteQuery() {
      var query = this.$route.query || {};
      this.SearchKey = query.searchkey || "";
      Object.keys(this.SearchData).forEach((key) => {
        var value = query[key] || "";
        if (value !== "" && NumericSearchKeys.indexOf(key) > -1) {
          value = Number(value);
        }
        this.SearchData[key] = value;
      });
      var page = parseInt(query.page, 10);
      this.Pagination.current_page = page > 0 ? page : 1;
    },
    SyncRouteQuery() {
      var query = this.BuildQuery();
      if (this.QuerySignature(query) == this.QuerySignature(this.$route.query)) {
        return;
      }
      this.$router.push({ query: query }).catch(() => {});
    },
    // --- Excel export --------------------------------------------------------
    BuildExportRow(Vehicle) {
      var row = {};
      row["VRM"] = Vehicle.vrm;
      row["Make"] = Vehicle.make;
      row["Model"] = Vehicle.model;
      row["MOT Exp"] = Vehicle.isMotExpired
        ? "Expired"
        : this.$options.filters.date(Vehicle.mot_due);
      row["Tax Exp"] = this.$options.filters.date(Vehicle.tax_due);
      return row;
    },
    // The grid only holds one page, so the export walks every page of the
    // current filter set. Passed to <export-excel> as its :fetch prop, which
    // awaits this before building the file.
    async FetchAllVehiclesForExport() {
      var rows = [];
      // A second click mid-sweep returns nothing, which makes <export-excel>
      // bail out rather than kicking off a duplicate run.
      if (this.ExportLoader) {
        return rows;
      }
      this.ExportLoader = true;
      try {
        var page = 1;
        var lastPage = 1;
        do {
          var Response = await Axios.post(
            Endpoints.Vehicle.List,
            this.BuildListRequest(page)
          );
          if (!Response?.data?.success) {
            break;
          }
          var Paginator = Response.data.vehicles || {};
          lastPage = Number(Paginator.last_page) || 1;
          Object.values(Paginator.data || {}).forEach((Vehicle) => {
            rows.push(this.BuildExportRow(Vehicle));
          });
          page++;
        } while (page <= lastPage);
      } catch (error) {
        console.error("Error exporting vehicles list:", error);
      } finally {
        this.ExportLoader = false;
      }
      return rows;
    },
    GetVehiclesListWithSafeStatus() {     
        var obj = {
          token: localStorage.getItem("token"),         
        };                
        Axios.post(Endpoints.Vehicle.ListWithSafeStatus, obj).then((Response) => {        
          if (Response?.data?.success) {          	            
            Response.data.vehicles.forEach((record) => {
                this.Vehicles.forEach((record2,index2) => {
                	if(record.id == record2.id){
                		this.Vehicles[index2]['last_vehicle_check'] = record['last_vehicle_check']
                		this.Vehicles[index2]['warning'] = record['warning']
                		this.Vehicles[index2]['unsafe'] = record['unsafe']
                	}
              	});
            });                                             
          }
        });      
    },
    AssignDriver(vehicle_id) {
      this.AssginVehicle.vehicle_id = vehicle_id;
      this.AssginVehicle.driver_id = 0;
    },
    ShowVehiclePosition(vehicle) {
    	this.ShowVehiclePositionModel = true;      
    	setTimeout(() => {
    		this.$refs.VehicleMaps.SetVehicleId(vehicle.id)
    		this.$refs.VehicleMaps.ShowVehicleMaps()
    	},500);
    },

    showVehicleAssetsModel(AssetList){
      this.AssetsList = AssetList;
    	this.ShowVehicleAssetsModel = true;   
      setTimeout(() => {
    		this.$refs.VehicleAssetsPopups.ShowVehicleAssetPopup()
    	},500);   
    },
  },
};
